import {
  DATA_VARIABLE,
  OBJECT_VARIABLE,
} from 'src/utils/stringify/rules/constants';

const getUniqueCreator = () => {
  const used = new Set<string>();
  return (value: string) => {
    if (!used.has(value)) {
      used.add(value);
      return value;
    }

    let counter = 0;
    let numbered = `${value}_${counter}`;
    while (used.has(numbered)) {
      counter += 1;
      numbered = `${value}_${counter}`;
    }
    used.add(numbered);
    return numbered;
  };
};

export const getRuleVariable = () => {
  const getUnique = getUniqueCreator();
  const variablesById: Record<string, string> = {};

  // start all variables with '_0' appended
  getUnique(OBJECT_VARIABLE);
  getUnique(DATA_VARIABLE);

  const getVariable = (variable: string, id?: string) => {
    if (!id) {
      return getUnique(variable);
    }

    const foundVariable = variablesById[id];
    if (variablesById[id]) {
      return foundVariable;
    }

    const newVariable = getUnique(variable);
    variablesById[id] = newVariable;
    return newVariable;
  };

  return { getVariable, variablesById };
};
